let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7XIZw"), load("11tIB"), load("9jGiN")]).then(() => parcelRequire('kvRiJ'));